<template>
  <div>
    <div>
      <div class="main_page">
        <div class="head_box">
          <div class="head_left">
            <img class="logo_img" src="@/assets/image/auth/logo_black.png" alt="" />

            <span class="head_title">大象·统一认证中心</span>
          </div>
        </div>
        <div :class="is_mobel ? 'mobile_main' : 'main'">
          <div>
            <div class="main_inner">

              <div :class="is_mobel ? 'login_box_2' : 'login_box'">
                <div class="login_tabs" v-if="show_tabs">
                  <Tabs v-model="current_tab" @on-click="click_tabs">
                    <TabPane v-if="!is_mobel" label="微信" name="weixin"></TabPane>
                    <TabPane label="帐号" name="username"></TabPane>

                    <TabPane label="短信" name="phone"></TabPane>

                    <TabPane v-if="!is_mobel" label="APP" name="qrcode"></TabPane>
                  </Tabs>
                </div>
                <div v-if="current_tab == 'weixin'">

                  <div id="login_container">

                  </div>
                </div>
                <div v-if="current_tab == 'username'">
                  <div class="login_input_box">
                    <div class="demo-login">
                      <Login @on-submit="username_submit">
                        <UserName name="username" :enter-to-submit="true" />

                        <Password name="password" type="password" :password="true" :enter-to-submit="true" />
                        <div class="username_yanzheng">
                          <div id="username_jiyan"></div>
                        </div>


                        <div style="height: 20px"></div>

                        <Submit />
                      </Login>
                    </div>
                  </div>
                </div>

                <div v-if="current_tab == 'phone'">
                  <div class="login_input_box">
                    <div class="demo-login">
                      <Login @on-submit="phone_submit">
                        <Mobile @on-change="phone_login_change" name="mobile" maxlength="11" :enter-to-submit="true" />

                        <Captcha count-down="30" name="captcha" :field="['mobile']" @on-get-captcha="send_sms"
                          :enter-to-submit="true" />
                        <div class="voice_code_div" v-if="sms_id">
                          长时间收不到短信验证码<span class="voice_click" @click="send_voice_code">
                            <Icon type="ios-call" />点击发送电话验证码
                          </span>
                        </div>
                        <!-- <div class="username_yanzheng">
                        <div id="phone_jiyan"></div>
                      </div> -->

                        <div style="height: 20px"></div>

                        <Submit :loading='phone_login_loading' />
                      </Login>
                    </div>
                  </div>
                </div>

                <div v-if="current_tab == 'qrcode'">
                  <div class="login_input_box3">
                    <div class="qrcode_img2" alt="" v-if="login_qrcode_load">
                      <Button loading shape="circle" type="primary"></Button>
                    </div>

                    <div ref="qrCodeUrl" class="qrcode_img" alt="" v-else></div>

                    <div class="qrcode_mb" v-if="scan_time > 0">
                      <Icon type="md-checkmark-circle" class="qrcode_sacn_icon" />

                      <div style="margin-top: 10px">扫码成功，请在手机上确认登录！</div>
                    </div>
                  </div>

                  <div class="login_input_box4">
                    <div class="qrcode_detail">{{ qr_login_title }}</div>

                    <div class="qrcode_detail2" @click="click_download_app">
                      没有APP？点击查看如何下载
                    </div>
                  </div>
                </div>


              </div>
            </div>
            <div class="xieyi">
              <Checkbox v-model="consent_xieyi"></Checkbox>

              我已阅读并同意

              <a href="/privacy_policy" target="_blank" class="xieyi_a">《隐私政策》</a>与

              <a target="_blank" href="/user_agreement" class="xieyi_a">《用户协议》</a>
            </div>
          </div>
        </div>
      </div>

    </div>

    <Modal :footer-hide="true" width="80" :closable="false" :mask-closable="false" v-model="is_wechat_env"
      title="系统环境提示">
      <div class="weixin_env_div">
        <div>检测到当前为微信浏览器，兼容性较差，可能会对使用造成影响！</div>

        <div>
          为了更好的使用体验，请点击右上角<span class="iconfont iconliulanqi"></span>地球图标，在默认浏览器中打开使用。
        </div>

        <div>😆感谢您的理解！</div>
      </div>
    </Modal>

    <!-- <cut_sys ref="cut_sys" @change="cut_sys_change"></cut_sys> -->
  </div>
</template>

<script>
var Base64 = require("js-base64").Base64;
const jsSHA = require("jssha");
import { http, open_new_page, get_browser_id } from "@/utils/http.js";
// import cut_sys from "@/views/login/cut_sys.vue";
import QRCode from "qrcodejs2";


export default {
  components: {
    // cut_sys,
  },
  data() {
    return {
      current_tab: "weixin",
      show_tabs: true,
      super_admin_show: false,
      admin_login_loading: false,
      redirect_url: "",
      sms_id: "",
      is_mobel: false,
      sys_name: "",
      qr_id: "",
      scan_time: 0,
      check_qrlogin_timer: null,
      login_qrcode_load: true,
      qr_login_title: "使用[大象系统]APP扫码登录~",
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      consent_xieyi: true,

      is_wechat_env: false,
      // 重定向url

      bgimg_url: "@/assets/image/auth/login_bg3.jpg",

      // 用户首页
      user_index_path: "/user/index/v2?type=message",
      // cookie作用域
      cookie_domain: "",

      voice_phone: '',
      // 极验验证成功标记
      // jiyan_username_result: null,
      // jiyan_username_obj: null,

      username_login_loading: false,
      phone_login_loading: false,
    };
  },
  created() {
    if (window.location.hostname == "localhost") {
      this.cookie_domain = "localhost";
    } else {
      this.cookie_domain = process.env.VUE_APP_COOKIES_DOMAIN;
    }

  },
  mounted() {
    var that = this;

    // 获取浏览器指纹
    get_browser_id()

    // 判断微信环境
    if (this.isWechat()) {
      this.is_wechat_env = true;
    } else {
      this.is_wechat_env = false;
    }

    this.window_change();
    // //判断手机端与电脑端
    this.is_mobel = this.isMobile();
    if (this.is_mobel) {
      this.current_tab = "phone";
      this.show_tabs = false;
      this.show_tabs = true;
    } else {
      // 如果是二维码登录-生成登录二维码
      if (this.current_tab == "qrcode") {
        if (this.check_qrlogin_timer) {
          clearInterval(this.check_qrlogin_timer);
        }
        setTimeout(() => {
          that.get_login_qrcode();
          that.login_qrcode_load = false;
        }, 1000);
      }
    }


    // 获取当前的重定向url
    var query = this.$route.query;
    var redirect_url = query.redirect_url;
    console.log(query);
    console.log(redirect_url);
    if (typeof redirect_url != "undefined") {
      console.log("登录后需要跳转");
      this.redirect_url = redirect_url;
    } else {
      console.log("登录后不需要跳转");
    }

    // 判断是否登录过，进行登录状态保持
    this.check_login_status();
    // 获取微信登录state码
    this.get_weixin_state();

  },
  methods: {

    // 放在 methods 里
    weixin_login_init() {
      const that = this

      // 容器不存在，直接 return（防止 tab 未切到 weixin）
      const container = document.getElementById('login_container')
      if (!container) {
        console.warn('微信登录容器不存在，跳过初始化')
        return
      }

      // 防止重复初始化
      container.innerHTML = ''

      // 动态加载 wxLogin.js
      if (!window.WxLogin) {
        const script = document.createElement('script')
        script.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'
        script.onload = () => that.render_wx_login()
        document.body.appendChild(script)
      } else {
        that.render_wx_login()
      }
    },

    render_wx_login() {
      const REDIRECT_URI = encodeURIComponent(
        'https://auth.daxiangsys.com/login/oauth_callback'
      )

      // 缩小样式
      var style_str = `\
      .impowerBox .qrcode{width:180px!important;height:180px!important;margin:0 auto!important}\
      .impowerBox .title{display:none!important}\
      .impowerBox .info{width:180px!important}\
      .impowerBox .status{text-align:center!important}\
      .status_icon{display:none!important}\
      iframe {width: 200px !important;height: 200px !important;border: none !important;}
      `

      var style_b64 = Base64.encode(style_str);

      // ✅ 强烈建议 false，SPA 用顶层跳转
      new window.WxLogin({
        self_redirect: false,
        id: 'login_container',
        appid: 'wx34d28a48d24cb0ee',
        scope: 'snsapi_login',
        redirect_uri: REDIRECT_URI,
        state: this.weixin_oauth_state,
        style: 'black',
        href: 'data:text/css;base64,' + style_b64
      })
    },



    isWechat() {
      //获取user-agaent标识头
      var ua = window.navigator.userAgent.toLowerCase();
      //判断ua和微信浏览器的标识头是否匹配
      if (ua.match(/micromessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },

    get_weixin_state() {
      var that = this;
      var browser_id = this.$cookies.get("dx_browser_id");
      if (browser_id == undefined) {
        browser_id = "";
      }
      var obj = {
        browser_id: browser_id,

      };
      http("post", process.env.VUE_APP_HOST + "/login_dx/oauth_state", obj, false)
        .then((res) => {
          if (res.code == 0) {
            that.weixin_oauth_state = res.data.state
            that.weixin_login_init()
          } else {
            that.$Message.error(res.msg)
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 判断是否登录过
    check_login_status() {
      console.log("判断是否登录过");
      var that = this;
      var obj = {
        redirect_url: this.redirect_url,
        token: this.$cookies.get("dx_token"),
      };

      http("post", process.env.VUE_APP_HOST + "/login_dx/is_login", obj, false, "staff")
        .then((res) => {
          console.log("判断是否登录login_status0000000000000000000000000");
          console.log(res);
          if (res.code == 0) {
            console.log("登录过，可跳转");
            that.$Message.success(res.msg);
            that.$router.push({
              path: that.user_index_path,
              query: { page: "message" },
            });

            // 有重定向，跳转到重定向页，没有的话到个人中心
            if (res.data.redirect_url) {
              setTimeout(function () {
                open_new_page(res.data.redirect_url, "_self");
              }, 200);
            } else {
              that.$router.push({
                path: that.user_index_path,
                query: { page: "message" },
              });
            }
          } else {
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    close_timer() {
      var that = this;
      if (that.check_qrlogin_timer) {
        clearInterval(this.check_qrlogin_timer);
      }
    },

    //检查二维码登录结果
    check_qrlogin_result() {
      var that = this;
      var browser_id = this.$cookies.get("dx_browser_id");
      console.log(browser_id);
      if (browser_id == undefined) {
        browser_id = "";
      }
      var obj = {
        browser_id: browser_id,
        qr_id: this.qr_id,
        redirect_url: that.redirect_url,
      };
      http("post", process.env.VUE_APP_HOST + "/login_dx/qr_login_check", obj, false)
        .then((res) => {
          if (res.code == 0) {
            console.log("登录成功", res);
            if (that.check_qrlogin_timer) {
              console.log("登录成功停止轮巡");
              clearInterval(that.check_qrlogin_timer);
            }

            var b64_str = Base64.decode(res.data.result);
            var data = JSON.parse(b64_str);


            that.$cookies.set(
              "dx_token",
              data.token,
              data.cookie_exp,
              "/",
              that.cookie_domain
            );
            that.$cookies.set(
              "dx_private_key",
              data.private_key,
              data.cookie_exp,
              "/",
              that.cookie_domain
            );
            that.$cookies.set(
              "dx_public_key",
              data.public_key,
              data.cookie_exp,
              "/",
              that.cookie_domain
            );

            that.$Message.success("登录成功");

            if (that.current_tab == "qrcode") {
              if (that.check_qrlogin_timer) {
                clearInterval(that.check_qrlogin_timer);
              }
            }

            // 有重定向，跳转到重定向页，没有的话到个人中心
            if (res.data.redirect_url) {
              setTimeout(function () {
                open_new_page(res.data.redirect_url, "_self");
              }, 200);
            } else {
              that.$router.push({
                path: that.user_index_path,
                query: { page: "message" },
              });
            }
          } else {
            if (res.data.scan_time > 0) {
              this.scan_time = res.data.scan_time;
            }
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取登录二维码
    get_login_qrcode() {
      console.log("获取登录二维码--------------------------");

      var that = this;
      var obj = {
        browser_id: this.$cookies.get("dx_browser_id"),
      };
      http("post", process.env.VUE_APP_HOST + "/login_dx/login_qrcode", obj, false)
        .then((res) => {
          if (res.code == 0) {
            console.log(res);
            that.qr_id = res.data.qr_id;

            that.$refs.qrCodeUrl.innerHTML = "";
            that.scan_time = 0;
            var qrcode = new QRCode(that.$refs.qrCodeUrl, {
              text: that.qr_id, // 需要转换为二维码的内容
              width: 149,
              height: 148,
              colorDark: "#000000",
              colorLight: "#ffffff",
              correctLevel: QRCode.CorrectLevel.H,
            });

            that.qr_login_title = "使用[大象系统]APP扫码登录~";

            if (that.check_qrlogin_timer) {
              clearInterval(that.check_qrlogin_timer);
            }
            // 开始轮巡检查结果
            that.check_qrlogin_timer = setInterval(function () {
              console.log("轮巡");
              that.check_qrlogin_result();
            }, 2000);

            setTimeout(function () {
              console.log("定时120秒关闭二维码检查轮询-----------******************");
              that.qr_login_title = "二维码登录超时，请刷新页面重新生成！";
              that.login_qrcode_load = true;
              that.close_timer();
            }, 120000);
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    isMobile() {
      var userAgentInfo = navigator.userAgent;

      var mobileAgents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];

      var mobile_flag = false;

      //根据userAgent判断是否是手机
      for (var v = 0; v < mobileAgents.length; v++) {
        if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
          mobile_flag = true;
          break;
        }
      }
      var screen_width = window.screen.width;
      var screen_height = window.screen.height;

      // //根据屏幕分辨率判断是否是手机
      // if (screen_width > 325 && screen_height < 750) {
      //   mobile_flag = true;
      // }

      return mobile_flag;
    },

    admin_login() {
      var that = this;
      var admin_token = that.$cookies.get("admin_token", "/", that.cookie_domain);
      var admin_private_key = that.$cookies.get(
        "admin_private_key",
        "/",
        that.cookie_domain
      );
      var admin_public_key = that.$cookies.get(
        "admin_public_key",
        "/",
        that.cookie_domain
      );
      var admin_user_info = that.$cookies.get("admin_user_info", "/", that.cookie_domain);

      if (admin_token && admin_private_key && admin_public_key && admin_user_info) {
        this.$Modal.confirm({
          title: "提示",
          content: "<p>检测到已经登录，需要直接登录吗？</p>",
          okText: "直接进入",
          cancelText: "重新登录",
          onOk: () => {
            if (that.check_qrlogin_timer) {
              clearInterval(that.check_qrlogin_timer);
            }
            that.$router.push({ path: "/auth_manage/sys/sys_setting" });
          },
          onCancel: () => {
            that.super_admin_show = true;
          },
        });
      } else {
        this.super_admin_show = true;
      }
    },

    phone_login_change(e) {
      console.log(e)
      this.voice_phone = e
    },

    send_voice_code() {
      if (this.voice_phone.length != 11) {
        this.$Message.error('请输入11位手机号码')
        return
      }
      if (this.sms_id == '') {
        this.$Message.error('请先尝试短信验证码')
      }
      var that = this;
      var obj = {
        phone: this.voice_phone,
        browser_id: String(this.$cookies.get("dx_browser_id")),
        is_voice: 1,
        old_sms_id: this.sms_id,
      };
      http("post", process.env.VUE_APP_HOST + "/login_dx/send_sms", obj, false)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });

    },

    //发送短信
    send_sms(value, values) {
      console.log(values);
      var that = this;

      var obj = {
        phone: values.mobile,
        browser_id: String(this.$cookies.get("dx_browser_id")),
      };
      http("post", process.env.VUE_APP_HOST + "/login_dx/send_sms", obj, false)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.sms_id = res.data.sms_id;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    phone_submit(valid, { mobile, captcha }) {
      var that = this;
      if (valid) {
        that.phone_login_loading = true

        console.log("短信登录");
        if (!that.consent_xieyi) {
          that.$Message.info("请先阅读并同意协议后再进行登录");
          return;
        }

        var obj1 = {
          phone: mobile,
          code: captcha,
          browser_id: that.$cookies.get("dx_browser_id"),
          sms_id: that.sms_id,
          redirect_url: that.$route.query.redirect_url,
        };
        var b64_str = Base64.encode(JSON.stringify(obj1));
        var obj = {
          data: b64_str,
        };

        http("post", process.env.VUE_APP_HOST + "/login_dx/sms_login", obj, false)
          .then((res) => {
            if (res.code == 0) {
              // const msg = this.$Message.loading({
              //   content: res.msg,
              //   duration: 0,
              // });
              var b64_str = Base64.decode(res.data);
              var data = JSON.parse(b64_str);

              that.$cookies.set(
                "dx_token",
                data.token,
                data.cookie_exp,
                "/",
                that.cookie_domain
              );
              that.$cookies.set(
                "dx_private_key",
                data.private_key,
                data.cookie_exp,
                "/",
                that.cookie_domain
              );
              that.$cookies.set(
                "dx_public_key",
                data.public_key,
                data.cookie_exp,
                "/",
                that.cookie_domain
              );

              // that.$cookies.set(
              //   "dx_user_info",
              //   data.user_info,
              //   data.cookie_exp,
              //   "/",
              //   that.cookie_domain
              // );

              var db_redirect_url = data.redirect_url;
              if (that.current_tab == "qrcode") {
                if (that.check_qrlogin_timer) {
                  clearInterval(that.check_qrlogin_timer);
                }
              }
              // 有重定向，跳转到重定向页，没有的话到个人中心
              if (db_redirect_url) {
                setTimeout(function () {
                  open_new_page(db_redirect_url, "_self");
                }, 200);
              } else {
                that.$router.push({
                  path: that.user_index_path,
                  query: { page: "message" },
                });
              }
            } else {
              that.$Message.error({
                content: res.msg,
                duration: 3,
              });
            }
            that.phone_login_loading = false

          })
          .catch((res) => {
            console.log(res, "请求出错");
            that.phone_login_loading = false
          });

      }

    },

    // 员工-用户密码登录
    username_submit(valid, { username, password }) {
      var that = this;

      // if (this.jiyan_username_result == null) {
      //   this.$Message.error('请先点击验证后再进行登录')
      //   return
      // }


      if (valid) {
        this.username_login_loading = true
        var user_name = Base64.encode(username);
        const shaObj = new jsSHA("SHA-1", "TEXT", { encoding: "UTF8" });
        shaObj.update(password);
        var pass_word = shaObj.getHash("HEX");

        let body_data = {
          username: user_name,
          password: pass_word,
          redirect_url: this.redirect_url,
          // jiyan_data: this.jiyan_username_result,
          scene_data: {
            browser_id: that.$cookies.get("dx_browser_id"),
          },
        };

        var body = Base64.encode(JSON.stringify(body_data));
        var obj = {
          data: body,
        };

        if (!this.consent_xieyi) {
          this.$Message.info("请先阅读并同意协议后再进行登录");
          return;
        }

        http("post", process.env.VUE_APP_HOST + "/login_dx/v1", obj, false)
          .then((res) => {
            if (res.code == 0) {
              // const msg = this.$Message.loading({
              //   content: res.msg,
              //   duration: 0,
              // });
              that.close_timer();
              var b64_str = Base64.decode(res.data);
              var data = JSON.parse(b64_str);
              console.log(data);

              that.$cookies.set(
                "dx_token",
                data.token,
                data.cookie_exp,
                "/",
                that.cookie_domain
              );
              that.$cookies.set(
                "dx_private_key",
                data.private_key,
                data.cookie_exp,
                "/",
                that.cookie_domain
              );
              that.$cookies.set(
                "dx_public_key",
                data.public_key,
                data.cookie_exp,
                "/",
                that.cookie_domain
              );

              // that.$cookies.set(
              //   "dx_user_info",
              //   data.user_info,
              //   data.cookie_exp,
              //   "/",
              //   that.cookie_domain
              // );
              console.log("登录成功了123");
              if (this.current_tab == "qrcode") {
                if (this.check_qrlogin_timer) {
                  clearInterval(this.check_qrlogin_timer);
                }
              }

              // 有重定向，跳转到重定向页，没有的话到个人中心
              if (data.redirect_url) {
                setTimeout(function () {
                  open_new_page(data.redirect_url, "_self");
                }, 200);
              } else {
                console.log("开始跳转个人中心2");
                console.log(that.user_index_path);
                var hostname = window.location.hostname;
                console.log(hostname);
                // if (hostname == "localhost") {
                //   open_new_page(that.user_index_path, "_self");
                // } else {
                that.$router.push({
                  path: that.user_index_path,
                  query: { page: "message" },
                });
                // }
              }
            } else {
              that.$Message.error({
                content: res.msg,
                duration: 3,
              });
            }
            that.jiyan_username_obj.reset();
            that.jiyan_username_result = null
            that.username_login_loading = false

          })
          .catch((res) => {
            console.log(res, "请求出错");
            that.jiyan_username_obj.reset();
            that.jiyan_username_result = null
            that.username_login_loading = false
          });
      }
    },

    //管理员登录
    admin_username_submit(valid, { username, password, auth2_code }) {
      var that = this;
      if (valid) {
        var user_name = Base64.encode(username);
        var pass_word_b64 = Base64.encode(password);
        const shaObj = new jsSHA("SHA-256", "TEXT", { encoding: "UTF8" });
        shaObj.update(pass_word_b64);
        var pass_word = shaObj.getHash("HEX");

        let body_data = {
          username: user_name,
          password: pass_word,
          code: auth2_code,
          scene_data: {
            browser_id: that.$cookies.get("browser_id"),
          },
        };
        that.admin_login_loading = true;
        var body = Base64.encode(JSON.stringify(body_data));
        var obj = {
          data: body,
        };
        http("post", process.env.VUE_APP_HOST + "/login_admin/v1", obj, false)
          .then((res) => {
            console.log(res);
            // 停止员工扫码登录qr验证
            if (that.check_qrlogin_timer) {
              clearInterval(that.check_qrlogin_timer);
            }
            that.admin_login_loading = false;
            if (res.code == 0) {
              that.$cookies.set(
                "admin_token",
                res.data.token,
                res.data.cookie_exp,
                "/",
                that.cookie_domain
              );
              that.$cookies.set(
                "admin_private_key",
                res.data.private_key,
                res.data.cookie_exp,
                "/",
                that.cookie_domain
              );
              that.$cookies.set(
                "admin_public_key",
                res.data.public_key,
                res.data.cookie_exp,
                "/",
                that.cookie_domain
              );
              that.$cookies.set(
                "admin_user_info",
                res.data.user_info,
                res.data.cookie_exp,
                "/",
                that.cookie_domain
              );
              that.$router.push({ path: "/auth_manage/sys/sys_setting" });

              that.$Message.success({
                content: res.msg,
                duration: 3,
              });
            } else {
              that.$Message.error({
                content: res.msg,
                duration: 3,
              });
            }
          })
          .catch((res) => {
            that.admin_login_loading = false;
            console.log(res, "请求出错");
          });
      }
    },

    click_tabs(e) {
      this.current_tab = e;
      var that = this;
      if (that.check_qrlogin_timer) {
        clearInterval(that.check_qrlogin_timer);
      }
      if (e == "qrcode") {
        // if (that.check_qrlogin_timer) {
        //   clearInterval(that.check_qrlogin_timer)
        // }
        console.log('切换到app登录')
        if (this.check_qrlogin_timer) {
          clearInterval(this.check_qrlogin_timer);
        }
        setTimeout(() => {
          that.get_login_qrcode();
          that.login_qrcode_load = false;
        }, 1000);
      } else {
        if (this.check_qrlogin_timer) {
          console.log('不是app登录,就取消定时器')
          clearInterval(this.check_qrlogin_timer);
        }
      }

      if (e == 'weixin') {
        this.get_weixin_state()
      }


      // if (e == 'phone') {
      //   // 注册极验模块
      //   initGeetest4({
      //     captchaId: '147ff865607a82fe313eb612fffde179',
      //     nativeButton: {
      //       width: "300px",
      //       height: "50px"
      //     },
      //     product:'bind'
      //     protocol: "https://"
      //   }, function (captcha) {
      //     that.jiyan_phone_obj = captcha;
      //     // captcha为验证码实例
      //     that.jiyan_phone_obj.appendTo("#phone_jiyan");

      //     that.jiyan_phone_obj.onSuccess(function () {
      //       var result = captcha.getValidate()
      //       console.log(result)
      //       that.jiyan_phone_result = result

      //     });


      //   });
      // }
      // if (e == 'username') {

      //   // 注册极验模块
      //   initGeetest4({
      //     captchaId: '147ff865607a82fe313eb612fffde179',
      //     nativeButton: {
      //       width: "300px",
      //       height: "50px"
      //     },
      //     protocol: "https://"
      //   }, function (captcha) {
      //     that.jiyan_username_obj = captcha;
      //     // captcha为验证码实例
      //     that.jiyan_username_obj.appendTo("#username_jiyan");

      //     that.jiyan_username_obj.onSuccess(function () {
      //       var result = captcha.getValidate()
      //       console.log(result)
      //       that.jiyan_username_result = result

      //     });


      //   });

      // }
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },

    click_download_app() {
      // this.$Message.info('请到手机应用商店搜索App【大象系统】安装',)
      this.$Modal.success({
        title: 'APP下载说明',
        content: '手机前往各大应用商店搜索 【大象系统】下载安装'
      });
      // open_new_page("https://www.daxiangsys.com");
    },

    click_beianhao() {
      open_new_page("https://beian.miit.gov.cn/");
    },
  },
};
</script>

<style scoped>
#login_container {
  padding-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

}

.username_yanzheng {
  display: flex;
  justify-content: center;
}

.voice_click {
  color: #2a77dc;
  cursor: pointer;
}

.voice_click:hover {
  color: #0466dd;

  font-weight: 600;
}

.voice_code_div {
  font-size: 13px;
  color: #949494
}

.weixin_env_div {
  padding-top: 100px;
  text-align: center;
  height: 300px;
  font-size: 15px;
  /* font-weight: 600; */
  color: #f62d34;
}

.xieyi_a {
  color: #0466dd;
}

.xieyi {
  text-align: center;
  font-size: 13px;
  padding-top: 10px;
  color: #888888;
}

.controller {
  -webkit-animation: bounce-down 3s linear infinite;
  animation: bounce-down 3s linear infinite;
  margin-right: 150px;
}

.controller2 {
  -webkit-animation: bounce-down 3s linear infinite;
  animation: bounce-down 3s linear infinite;
  margin-right: 30px;
}

@-webkit-keyframes bounce-down {
  25% {
    -webkit-transform: translateY(-10px);
  }

  50%,
  100% {
    -webkit-transform: translateY(0);
  }

  75% {
    -webkit-transform: translateY(10px);
  }
}

@keyframes bounce-down {
  25% {
    transform: translateY(-10px);
  }

  50%,
  100% {
    transform: translateY(0);
  }

  75% {
    transform: translateY(10px);
  }
}

.super_admin_login {
  color: #2d6ebe;
  font-size: 13px;
}

.super_admin_login:hover {
  color: #fff;
}

.head_right {
  margin-right: 50px;
}

.head_left {
  display: flex;
  align-items: center;
}

.qrcode_detail {
  margin-top: 20px;
  font-size: 12px;
  color: #777;
}

.qrcode_detail2 {
  margin-top: 20px;
  font-size: 12px;
  color: #ccc;
  cursor: pointer;
}

.qrcode_detail2:hover {
  color: #195faf;
}

.qrcode_sacn_icon {
  font-size: 40px;
  color: #19be6b;
}

.qrcode_mb {
  padding: 30px 20px 20px 20px;
  background-color: #00000094;
  position: absolute;
  width: 150px;
  height: 150px;
  top: 40px;
  left: 115px;
  font-size: 13px;
  color: #eaeaea;
  font-weight: 600;
}

.qrcode_img {
  width: 150px;
  height: 150px;
  text-align: center;
  border: 1px solid #ccc;
}

.qrcode_img2 {
  width: 150px;
  height: 150px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
}

.input {
  margin: 10px;
}

.login_input_box {
  text-align: center;
  padding: 30px 60px 40px 60px;
}

.login_input_box4 {
  text-align: center;
  padding: 0px 40px 10px 40px;
}

.login_input_box3 {
  text-align: center;
  position: relative;
  padding: 30px 40px 5px 40px;
  display: flex;
  justify-content: center;
}

.login_input_box2 {
  text-align: center;
  padding: 10px 30px 40px 30px;
}

.login_tabs {
  display: flex;
  justify-content: center;
  padding-top: 30px;
}

.login_tabs_mobile {
  display: flex;
  justify-content: center;
  padding: 20px;
}

.main_inner {
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin: 10px 0px 0 0; */
}

.logo_img {
  width: 40px;
  height: 40px;
  margin-right: 7px;
  margin-bottom: 5px;
}

.main_page {
  height: 100vh;
  background-size: cover;
  background-image: url("@/assets/image/auth/login_bg3.jpg");
}

.head_title {
  cursor: pointer;
  letter-spacing: 3px;
  font-size: 18px;
  font-weight: 500;
  color: rgb(19, 19, 19);
}

.bottom_beianhao {
  height: 60px;
  background: #fcfcfc;
  text-align: center;
  font-size: 12px;
  color: #ccc;
  cursor: pointer;
}

.head_box_mobil {
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 0 20px;
}

.head_box {
  /* background: #195faf; */
  height: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1em 0 0 2em;
}

.bg {
  height: 300px;
  width: 460px;
}

.bg2 {
  height: 240px;
  width: 360px;
}

.main {
  height: calc(100vh - 140px);
  width: calc(100vw - 100px);
  display: flex;
  /* background: red; */
  justify-content: center;
  align-items: center;
}

/deep/ .ivu-tabs-ink-bar {
  height: 3px;
}

.mobile_main {
  height: calc(100vh - 140px);
  display: flex;
  /* background: red; */
  justify-content: center;
  align-items: center;
}

/deep/ .ivu-btn-default {
  font-size: 12px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #0466dd;
  color: #fff;
}

.login_box {
  border-radius: 5px;
  /* width: 380px; */
  width: 420px;
  /* height: 440px; */
  height: 380px;
  background: #ffffff;
  box-shadow: 0 0 10px rgb(222, 223, 224);
}

.login_box_2 {
  border-radius: 5px;
  height: 400px;
  background: #ffffff;
}

.login_box_mobile {
  margin: 10px;
  border-radius: 5px;
  height: 330px;
  /* background: #ffffff; */
  /* box-shadow: 0 0 10px rgb(222, 223, 224); */
}
</style>
